// src/WeeklyShipmentsChart.jsx
import React from "react";
import {
	LineChart,
	Line,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	ResponsiveContainer,
	Legend,
} from "recharts";

const data = [
	{ week: "Week 1", shipments: 400 },
	{ week: "Week 2", shipments: 700 },
	{ week: "Week 3", shipments: 300 },
	{ week: "Week 4", shipments: 900 },
	{ week: "Week 5", shipments: 500 },
	{ week: "Week 6", shipments: 800 },
];

const WeeklyShipmentsChart = () => (
	<ResponsiveContainer width="100%" height={250}>
		<LineChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
			<CartesianGrid strokeDasharray="3 3" />
			<XAxis dataKey="week" />
			<YAxis />
			<Tooltip />
			<Legend />
			<Line
				type="monotone"
				dataKey="shipments"
				stroke="#1976d2"
				strokeWidth={3}
				activeDot={{ r: 8 }}
			/>
		</LineChart>
	</ResponsiveContainer>
);

export default WeeklyShipmentsChart;
